import * as React from "react";
import { StakeModifier } from "../../../../data/models";
import { StakeButton } from "../StakeButton";
import { StakeValue } from "../StakeValue";
export class StakeHolder extends React.Component {
    render() {
        const { stakeFormatted, isMinusDisabled, isPlusDisabled } = this.props.data;
        return (React.createElement("div", { className: "rj-my-pulse-bets__stake-holder" },
            React.createElement(StakeButton, { handler: e => { this.props.data.stakeDown(this.props.data.eventId); }, isActive: isMinusDisabled, modifier: StakeModifier.minus }),
            React.createElement(StakeButton, { handler: e => { this.props.data.stakeUp(this.props.data.eventId); }, isActive: isPlusDisabled, modifier: StakeModifier.plus }),
            React.createElement(StakeValue, { stakeValue: stakeFormatted })));
    }
}
//# sourceMappingURL=StakeHolder.js.map